import { useSuspenseQuery } from '@tanstack/react-query';

import { getDoctoralCommitteeValidationHistoryOptions } from '@/module/Author/DoctoralCommittee/Validation/model/DoctoralCommitteeValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface DoctoralCommitteeValidationHistoryProps {
  doctoralCommitteeId: Id;
}

export function DoctoralCommitteeValidationHistory({ doctoralCommitteeId }: DoctoralCommitteeValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getDoctoralCommitteeValidationHistoryOptions(doctoralCommitteeId));

  return <ValidationHistoryContent history={history} />;
}
